import { render, staticRenderFns } from "./OrdersGridFilters.vue?vue&type=template&id=4448e99d&scoped=true"
import script from "./OrdersGridFilters.vue?vue&type=script&lang=js"
export * from "./OrdersGridFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448e99d",
  null
  
)

export default component.exports